// Pure builder for a single HubSpot contact result row in the search dropdown.
// Shared by the typed contact search and the `for: <Name>` QuickSet resolution
// (both go through showContactDropdown). Kept as a pure function with an injected
// `escapeHtml` so it can be unit-tested without a DOM.
//
// Layout: bold name, then a muted `email · phone` tail. Email and phone are each
// optional — a blank/absent value is dropped along with its separator, so a
// contact with no phone shows just the email, and one with neither shows the
// name alone (never an empty span, stray "·", or "undefined"). CFPK keeps the
// number in `mobilephone`, so prefer it over the standard `phone`.
export function contactRowHtml(contact, escapeHtml) {
  const name = `${escapeHtml(contact.firstname)} ${escapeHtml(contact.lastname)}`
  const phone = contact.mobilephone || contact.phone || contact.secondary_mobile_phone_number
  const meta = [contact.email, phone]
    .map(v => (v == null ? '' : String(v).trim()))
    .filter(Boolean)
    .map(escapeHtml)
    .join(' · ')

  let html = `<span class="font-medium">${name}</span>`
  if (meta) {
    html += `<span class="text-base-content/50 text-xs ml-2">${meta}</span>`
  }
  return html
}
